import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarHttpModule } from '@ngx-loading-bar/http';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { LoadingBarModule } from '@ngx-loading-bar/core';

import { JWT_OPTIONS, JwtModule } from '@auth0/angular-jwt';

import { AgmCoreModule } from '@agm/core';
import { MsalInterceptor, MsalModule } from '@azure/msal-angular';

import { NgSelectModule } from '@ng-select/ng-select';

import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { FeaturesModule } from './features/features.module';

import { AppComponent } from './app.component';

import { OAuthSettings } from './core/auth/msal/msal.config';

export function tokenGetterFactory() {
  return localStorage.getItem('userToken');
}

export function jwtOptionsFactory() {
  return {
    tokenGetter: tokenGetterFactory,
    whitelistedDomains: [ /^null$/ ]
  };
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
    FeaturesModule,
    HttpClientModule,

    LoadingBarHttpClientModule,
    LoadingBarHttpModule,
    LoadingBarRouterModule,
    LoadingBarHttpClientModule,
    LoadingBarModule.forRoot(),

    NgSelectModule,

    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBm2OnD1VSw50CRkKCW0lHpqp21ioE5BBc',
      libraries: [ 'places' ]
    }),

    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory
      }
    }),

    MsalModule.forRoot(
      OAuthSettings
    )
  ],
  // COMMENT this obj to allow the `mock-server` to run properly
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    }
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  bootstrap: [ AppComponent ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./client/app/app.module.ts